import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const runtimeEnv =
	typeof window === "undefined"
		? (process.env as unknown as Record<string, string | undefined>)
		: import.meta.env;

export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_PUBLIC_SERVER: z.string().trim().url().optional(),
		VITE_SENTRY_DSN: z.string().trim().url().optional(),
		VITE_CLI_PERFORMANCE_REPORT_ENABLED: z
			.enum(["true", "false"])
			.default("false"),
	},
	runtimeEnv,
	emptyStringAsUndefined: true,
});
